import { z } from 'zod';
import { ReportReason, ReportStatus } from '../enums.js';
import { IdempotencyKeySchema, IsoDateTimeSchema, UuidSchema } from '../primitives.js';

export const ReportSchema = z.object({
  id: UuidSchema,
  reporterUserId: UuidSchema,
  reportedUserId: UuidSchema,
  reason: ReportReason,
  details: z.string().trim().max(2000).nullable(),
  /** Optional reference to a specific message that triggered the report. */
  contextMessageId: UuidSchema.nullable(),
  status: ReportStatus,
  resolutionNote: z.string().nullable(),
  resolvedByAdminId: UuidSchema.nullable(),
  createdAt: IsoDateTimeSchema,
  resolvedAt: IsoDateTimeSchema.nullable(),
});
export type Report = z.infer<typeof ReportSchema>;

export const SubmitReportRequestSchema = z.object({
  reportedUserId: UuidSchema,
  reason: ReportReason,
  details: z.string().trim().max(2000).optional(),
  contextMessageId: UuidSchema.optional(),
  idempotencyKey: IdempotencyKeySchema,
});
export type SubmitReportRequest = z.infer<typeof SubmitReportRequestSchema>;
